<template>
  <div id="email-app" class="content-area__content relative">
    <div id="faq-page">
      <!-- <div class="faq-jumbotron">
        <vx-card class="faq-jumbotron-content lg:p-16 md:p-16 sm:p-8 p-8 rounded-lg mb-base" style="background-size: cover;"
        title="한줄 질문을 해보세요 :D"
        title-color="#fff"
        content-color="primary"
        :card-background="'url(' + card_bg_img_1 + ')'">
          <div class="vs-con-input w-full">
            <p class="mb-3 text-white"><strong>교수님의 빠른 피드백을 받을 수 있을거에요 :)</strong></p>
            <p class="mb-3 text-white">질문했던 내용을 빨리 찾으려면 검색해보세요.</p>
            <vs-input icon-pack="feather" color="dark" icon="icon-search" size="large" placeholder="Search" v-model="searchKeywoard" class="is-label-placeholder lg:w-full" /><br>
          </div>
        </vx-card>
      </div> -->

      <div class="vx-row ml-auto cursor-pointer">
        <div style="width:96%;">
          <div align="left" style="margin-left:10px;">
            <div class="vx-row">
              <vs-checkbox v-model="checkboxVal[0]">완료 답변</vs-checkbox>
              <vs-checkbox v-model="checkboxVal[1]">미답변</vs-checkbox>
              <vs-checkbox v-if='activeUserLevel == 2' v-model="userCheckboxVal">내글만</vs-checkbox>
            </div>
          </div>
        </div>
        <div class="vx-row justify-end">
          <div align="right" style="margin-right:3px;">
          <div class="ml-auto cursor-pointer mb-base">
            <feather-icon icon="EditIcon" svg-classes="h-6 w-6" v-if='activeUserLevel == 2 && activeSpaceInfo.service == true' @click="activePrompt = true, question='' " /> &nbsp;&nbsp;&nbsp;
          </div>
          </div>
        </div>
      </div>
      <vs-input icon-pack="feather" color="dark" icon="icon-search" size="large" placeholder="Search" v-model="searchKeywoard" class="is-label-placeholder lg:w-full" /><br>
      <div class="vx-col">
        <div class="vs-collapse p-0 margin">
          <div class="vs-collapse-item faq-bg rounded-lg mt-0">
            <vs-collapse accordion>
              <vs-collapse-item v-for="noticeBoard in noticeBoardList" :key="noticeBoard.id">
                <div slot="header">
                  <div class="vx-row" style="margin:10px;">
                    <div class="vx-row" style="margin:10px; padding:2px;">
                      <vs-chip v-if="!noticeBoard.answer" color="#d5d5d5" style="width:100%; height:20px; margin-right:10px;">대기</vs-chip>
                      <vs-chip v-if="noticeBoard.answer" color="#28c76f" style="margin-right:10px;">완료</vs-chip>
                    </div>
                    <div style="margin-top:10px;" v-html="noticeBoard.question"/>
                    <div class="ml-auto md:block cursor-pointer">
                      <div class="vx-row" v-if='activeUserInfo.uid == noticeBoard.user_id && activeSpaceInfo.service == true && !noticeBoard.answer' style="margin-top:10px;">
                        <vs-button color="dark" icon-pack="feather" icon="icon-edit-2" type="flat" svg-classes="h-6 w-6" style="margin-right:5px"  @click="openQuestion(noticeBoard)" />
                        <vs-button color="dark" @click="deleteQuestion(noticeBoard.id)" style="margin-right:20px" type="flat" icon="icon-trash" icon-pack="feather" />
                      </div>
                      <div class="vx-row" v-if='activeUserLevel >= 3 && activeSpaceInfo.service == true'>
                        <vs-button color="dark" icon-pack="feather" icon="icon-message-square" type="flat" svg-classes="h-6 w-6" style="margin-right:20px"  v-show="!noticeBoard.answer"  @click="openAnswer(noticeBoard)" />
                      </div>
                    </div>
                  </div>
                </div>
                <div class="vx-row" style="margin:10px;"  v-show="noticeBoard.answer">
                  <div v-html="noticeBoard.answer"/>
                  <div class="ml-auto md:block cursor-pointer">
                    <div class="vx-row">
                      <vs-button color="dark" icon-pack="feather" icon="icon-edit-2" type="flat" svg-classes="h-6 w-6" style="margin-right:5px" v-if='activeUserLevel >= 3 && activeSpaceInfo.service == true' @click="openAnswer(noticeBoard)" />
                        <vs-button color="dark" v-if='activeUserLevel >= 3 && activeSpaceInfo == true' @click="deleteAnswer(noticeBoard.id)" style="margin-right:5px" type="flat" icon="icon-trash" icon-pack="feather"  />
                    </div>
                  </div>
                </div>
              </vs-collapse-item>
            </vs-collapse>
          </div>
        </div>
      </div>
    </div>
    <vs-prompt
      class="email-compose"
      title="한 줄 질문하기"
      accept-text= "업로드"
      cancel-text= "취소"
      @cancel="clearFields"
      @close="clearFields"
      @accept="createQuestion"
      :active.sync="activePrompt">
      <component :is="scrollbarTag" class="scroll-area p-6 mb-4" :settings="settings" :key="$vs.rtl">
        <form @submit.prevent>
          <vs-textarea counter="500" :counter-danger.sync="counterDanger" v-model="question" />
        </form>
      </component>
    </vs-prompt>

    <vs-prompt
      class="email-compose"
      title="한 줄 질문 수정"
      accept-text= "업로드"
      cancel-text= "취소"
      @cancel="clearFields"
      @close="clearFields"
      @accept="updateQuestion"
      :active.sync="activePrompt2">
      <component :is="scrollbarTag" class="scroll-area p-4" :settings="settings" :key="$vs.rtl">
        <form @submit.prevent>
          <vs-textarea counter="500" :counter-danger.sync="counterDanger" v-model="question"/>
        </form>
      </component>
    </vs-prompt>
    <vs-prompt
    class="email-compose"
    title="답변하기"
    accept-text= "업로드"
    cancel-text= "취소"
    @cancel="clearFields"
    @close="clearFields"
    @accept="createAnswer"
    :active.sync="activeAnswerPrompt">
      <component :is="scrollbarTag" class="scroll-area p-4" :settings="settings" :key="$vs.rtl">
        <form @submit.prevent>
          <h3>질문</h3>
          <div v-html="activeNoticeBoard.question"></div><br/>
          <vs-textarea counter="500" :counter-danger.sync="counterDanger" v-model="answer"/>
        </form>
      </component>
    </vs-prompt>
  </div>
</template>
<script>
import noticeBoard from "@/views/apps/space/dashboard/noticeBoard/NoticeBoardItem.vue"
import VuePerfectScrollbar from 'vue-perfect-scrollbar'
import { quillEditor } from 'vue-quill-editor'

export default{
  data() {
    return {
      title: '',
      answer: '',
      question: '',
      deleteId:0,
      counterDanger: false,
      activeAnswerPrompt: false,
      activePrompt: false,
      activePrompt2: false,
      activeNoticeBoard: {},
      noticeBoardList: [],
      checkboxVal:[true,true],
      userCheckboxVal: false,
      editorOption: {
        modules: {
          toolbar: '#toolbar'
        },
        placeholder: '내용을 입력하세요.'
      },
      activeConfirm: false,
       settings             : {
         maxScrollbarLength : 60,
         wheelSpeed         : 0.30,
       },
      content: ``,
      searchQuery: {
        keywoard:'',
        id:0,
        state:0
      },
      searchKeywoard:'',
      titlevalue1:'',
      type: 'shadow',
      QnApopupActive2: false,
      card_bg_img_1: require('@/assets/images/pages/faq.jpg')
    }
  },
  watch: {
    searchKeywoard(){
      this.searchQuery.keywoard = this.searchKeywoard
      this.$store.commit('noticeBoard/SET_NOTICEBOARD_SEARCH_QUERY', this.searchQuery)
      this.noticeBoardList = this.$store.getters['noticeBoard/filteredNoticeBoard']
    },
    userCheckboxVal(){
      if(this.userCheckboxVal){
        this.checkboxVal[0] = false
        this.checkboxVal[1] = false
        this.searchQuery.id = this.activeUserInfo.uid
      } else {
        this.searchQuery.id = 0
      }
      if(!this.checkboxVal[0] && !this.checkboxVal[1] && !this.userCheckboxVal){
        this.noticeBoardList = []
      }
      else {
        this.$store.commit('noticeBoard/SET_NOTICEBOARD_SEARCH_QUERY', this.searchQuery)
        this.noticeBoardList = this.$store.getters['noticeBoard/filteredNoticeBoard']
      }
    },
    checkboxVal(){
      if(this.checkboxVal[0] || this.checkboxVal[1]){
        this.userCheckboxVal = false
      }
      if(!this.checkboxVal[0] && !this.checkboxVal[1] && !this.userCheckboxVal){
        this.noticeBoardList = []
        return
      }
      if (this.checkboxVal[0] && this.checkboxVal[1]){
        this.searchQuery.state = 0
      } else if (!this.checkboxVal[0] && !this.checkboxVal[1]){
        this.searchQuery.state = 3
      } else if (!this.checkboxVal[1]){ // 완료만.
        this.searchQuery.state = 1
      } else { // 미답글만.
        this.searchQuery.state = 2
      }
      this.$store.commit('noticeBoard/SET_NOTICEBOARD_SEARCH_QUERY', this.searchQuery)
      this.noticeBoardList = this.$store.getters['noticeBoard/filteredNoticeBoard']
    }
  },
  components: {
    quillEditor,
    'noticeBoard':noticeBoard,
    VuePerfectScrollbar
  },
  methods: {
    updateQuestion(){
      if(this.question.length > 512){
        this.$vs.notify({
          color: 'danger',
          title: '에러',
          text: '500자 이내로 작성 해주세요'
        })
        return
      }
      this.$store.dispatch('noticeBoard/updateQuestion', {"question": this.question, "id": this.activeNoticeBoard.id, "workspaceId": this.$store.state.space.ActiveSpaceInfo.id}).then(() => {
        this.noticeBoardList = this.$store.state.noticeBoard.noticeBoards
      })
    },
    acceptAlert() {
      this.$router.push('/apps/space')
    },
    deleteAnswer(id) {
     this.deleteId = id
     this.$vs.dialog({
       type: 'confirm',
       color: 'danger',
       title: `답변 삭제`,
       text: '해당 답변을 삭제하시겠습니까?',
       accept: this.acceptDeleteAnswer
     })
    },
    deleteQuestion(id) {
      this.deleteId = id
      this.$vs.dialog({
        type: 'confirm',
        color: 'danger',
        title: `질문 삭제`,
        text: '해당 질문을 삭제하시겠습니까?',
        accept: this.acceptDeleteQuestion
      })
    },
    clearFields() {
     this.$nextTick(() => {
       this.answer = ''
       this.question = ''
     })
    },
    createAnswer () {
     this.clearFields()
     this.$store.dispatch('noticeBoard/createAnswer', {"answer": this.answer, "id": this.activeNoticeBoard.id, "workspaceId": this.$store.state.space.ActiveSpaceInfo.id}).then(() => {
       this.noticeBoardList = this.$store.state.noticeBoard.noticeBoards
     })
    },
    createQuestion () {
     this.clearFields()
     if(this.question.length > 512){
       this.$vs.notify({
         color: 'danger',
         title: '에러',
         text: '500자 이내로 작성 해주세요'
       })
       return
     }
     this.$store.dispatch('noticeBoard/createQuestion', {"question": this.question, "workspaceId": this.$store.state.space.ActiveSpaceInfo.id}).then(() => {
       this.noticeBoardList = this.$store.state.noticeBoard.noticeBoards
     })
    },
    acceptDeleteQuestion() {
     this.$store.dispatch('noticeBoard/deleteQuestion', {"id": this.deleteId}).then(() => {
       this.noticeBoardList = this.$store.state.noticeBoard.noticeBoards
     })
     this.$vs.notify({
       color: 'danger',
       title: '게시글 삭제 완료',
       text: '삭제되었습니다'
     })
    },
    acceptDeleteAnswer() {
     this.$store.dispatch('noticeBoard/deleteAnswer', {"id": this.deleteId, "workspaceId": this.$store.state.space.ActiveSpaceInfo.id}).then((resolve) => {
      if(resolve.data.result == 'success'){
         this.noticeBoardList = this.$store.state.noticeBoard.noticeBoards
         this.$vs.notify({
           color: 'danger',
           title: '게시글 삭제 완료',
           text: '삭제되었습니다'
         })
        }
     })
    },
    openQuestion(noticeBoard) {
     this.activeNoticeBoard = noticeBoard
     this.question = noticeBoard.question
     this.activePrompt2 = true
    },
    openAnswer(noticeBoard) {
     this.activeNoticeBoard = noticeBoard
     this.answer = noticeBoard.answer
     this.activeAnswerPrompt = true
    }
  },
  computed: {
   scrollbarTag() { return this.$store.getters.scrollbarTag },
   windowWidth() {
     return this.$store.state.windowWidth
   },
   activeUserLevel() {
     return this.$store.state.space.ActiveDashBoardLevel
   },
   activeUserInfo() {
     return this.$store.state.AppActiveUser
   },
   activeSpaceInfo() {
     return this.$store.state.space.ActiveSpaceInfo
   },
  },
  created() {
   if(this.$store.state.space.ActiveSpaceInfo.id == 0){
     this.$vs.dialog({
       color: 'danger',
       title: 'error',
       text: 'Workspace 주소가 정확한지 확인해 주세요.',
       accept: this.acceptAlert
     })
     return
   }
   this.$store.dispatch('noticeBoard/getNoticeBoard', this.$store.state.space.ActiveSpaceInfo.id).then(()=>{
     this.noticeBoardList = this.$store.state.noticeBoard.noticeBoards
   })
  }
}
</script>
